import { useMutation } from '@tanstack/react-query';
import { HttpService } from '@Services/index';
import { useBoundStore } from '@Store/useBoundStore';

interface ValidateMfaRequest {
  answer: string;
}

interface ValidateMfaResponse {
  allowEditingPersonalDetails: boolean;
}

export const validateAuthorizedUserMfa = async (
  data: ValidateMfaRequest
): Promise<ValidateMfaResponse> => {
  const { customerId, authorizedUserId } = useBoundStore.getState().onboardingSlice;

  if (!customerId) {
    const url = `v5/onboarding/authorized/user/${authorizedUserId}/validateMfa`;
    const response = await HttpService.post<ValidateMfaResponse>(url, {
      answer: data.answer,
      mfaType: 'SMS',
    });
    return response.data as ValidateMfaResponse;
  }

  const url = `v5/onboarding/user/${customerId}/authorized/user/${authorizedUserId}/validateMfa`;

  const response = await HttpService.post<ValidateMfaResponse>(url, {
    answer: data.answer,
    mfaType: 'SMS',
  });
  return response.data as ValidateMfaResponse;
};

export const useValidateAuthorizedUserMfa = () =>
  useMutation({
    mutationFn: validateAuthorizedUserMfa,
  });

export const SendMfaCode = async () => {
  const { customerId, authorizedUserId } = useBoundStore.getState().onboardingSlice;

  if (!customerId) {
    const url = `v3/onboarding/authorized/user/${authorizedUserId}/sendOtp`;
    await HttpService.post(url, { mfaType: 'SMS' });
    return;
  }

  const url = `v3/onboarding/user/${customerId}/authorized/user/${authorizedUserId}/sendOtp`;

  await HttpService.post(url, {
    mfaType: 'SMS',
  });
};

export const useSendMfaCode = () =>
  useMutation({
    mutationFn: SendMfaCode,
  });
